import React, { useState, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SignInDialogUi } from "~/components";
import { useCampaignPage } from "~/store";
import { usePassions } from "../../../hooks/usePassions2";
import { useAcid } from "../../../hooks/useAcid";
import { SurveyStart } from "./SurveyStart";
import { Survey } from "./Survey";
import { surveyDataV3, getStartedVideoIdV3 } from "./surveyDataV3";
import { sendAnalyticsPageViewEvent } from "../../../utils/adobeDataLayerUtils";

const cid = "video";

export const VideoPassionsV3 = () => {
  const { acid } = useAcid();
  const navigate = useNavigate();
  const [showSignInDialog, setShowSignInDialog] = useState(false);
  const { setShowPageLoader } = useCampaignPage();

  useEffect(() => {
    sendAnalyticsPageViewEvent("Passions-Video", 'Passions-Collection', 'video');
  }, []);

  // Randomize survey data order using Fisher-Yates shuffle
  const [data] = useState(() => {
    const shuffled = [...surveyDataV3];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  });
  const {
    selectPassion,
    dislikePassion,
    savePassionsToServer,
    getSelectedPassionsAsArray,
    getSelectedPassionsAsFlatArray,
  } = usePassions(cid);

  const [currentIndex, setCurrentIndex] = useState(-1);
  const startSurvey = () => {
    setCurrentIndex(0);
    if (!acid) {
      setShowSignInDialog(true);
      return;
    }
  };
  const next = (action) => {
    const { passionId, passionName } = data[currentIndex];
    const nextIndex = currentIndex + 1;
    const nextPassion = data[nextIndex];
    const id = passionId ?? passionName.toLowerCase();

    // If "yes" clicked
    if (action === true) {
      selectPassion(id);
    }

    // If "no" clicked
    if (action === false) {
      dislikePassion(id);
    }

    savePassionsToServer(acid);
    if (nextPassion) {
      setCurrentIndex(nextIndex);
    } else {
      navigate("/video/explore");
    }
  };

  const onCloseDialog = useCallback(
    () => setShowSignInDialog(false),
    [setShowSignInDialog],
  );

  const onSubmitDialog = useCallback(() => {
    onCloseDialog();
    setShowPageLoader(true);
  }, [onCloseDialog, setShowPageLoader]);

  if (currentIndex >= 0) {
    return (
      <>
        <Survey data={data[currentIndex]} next={next} hasDelay={false} />
        {showSignInDialog && (
          <SignInDialogUi
            onClose={onCloseDialog}
            onSubmit={onSubmitDialog}
            selectedPassions={getSelectedPassionsAsFlatArray()}
            cid={cid}
          />
        )}
      </>
    );
  }

  return <SurveyStart next={startSurvey} videoId={getStartedVideoIdV3} />;
};
